import React, { createContext, useContext, useState, ReactNode } from "react";

// 1. Survey data interface
export interface SurveyData {
  optionalEmail: string;
  projectNumber: string;
  WorkArrangementsTool: Record<string, string>;
  PriorSleepWakeTool: Record<string, number>;
  SelfReportTool: Record<string, string>; // ✅ Added this line
}

// 2. Default state
const defaultSurveyState: SurveyData = {
  optionalEmail: "",
  projectNumber: "",
  WorkArrangementsTool: {},
  PriorSleepWakeTool: {},
  SelfReportTool: {}, // ✅ Added this line
};

// 3. Context type
interface SurveyContextType {
  surveyData: SurveyData;
  setSurveyData: React.Dispatch<React.SetStateAction<SurveyData>>;
}

// 4. Create context
const SurveyContext = createContext<SurveyContextType>({
  surveyData: defaultSurveyState,
  setSurveyData: () => {
    // no-op
  },
});

// 5. Provider
export const SurveyProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [surveyData, setSurveyData] = useState<SurveyData>(defaultSurveyState);

  return (
    <SurveyContext.Provider value={{ surveyData, setSurveyData }}>
      {children}
    </SurveyContext.Provider>
  );
};

// 6. Custom hook
export const useSurveyContext = (): SurveyContextType => useContext(SurveyContext);

// 7. Optional export
export { SurveyContext, defaultSurveyState };
